import { render, staticRenderFns } from "./CallReservation.vue?vue&type=template&id=1cb5f5f2&scoped=true"
import script from "./CallReservation.vue?vue&type=script&lang=js"
export * from "./CallReservation.vue?vue&type=script&lang=js"
import style0 from "./CallReservation.vue?vue&type=style&index=0&id=1cb5f5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb5f5f2",
  null
  
)

export default component.exports